<template>

<header class="admin-header">
	<div class="brand">
		<div>
			<img src="@/assets/img/IconFlightDeckLight.png">
		</div>
		<div>
			Your Dashboard
		</div>
	</div>

	<nav role="main" :class="{ mobileshow: hamburgerOn }" v-if="getUser.user_type_code">
		<ul>
			<li><a href="/ordermenu.php">Orders &amp; Sales</a></li>
			<li><a href="/inventorymenu.php">Inventory &amp; Pricing</a></li>
			<li><a href="/posmenu.php">POS &amp; Range</a></li>
			<li><a href="/websitemenu.php">Features &amp; Content</a></li>
			<li><a href="/accountmenu.php">Checkout &amp; Accounts</a></li>
			<li><a href="/batchordermaintenance.php">Cart [<span id="cart_item_count">{{ items_in_cart }}</span>]</a></li>
			<li><router-link :to='getLoginRoute + "?logout=true"'>Log Out</router-link></li>
		</ul>
	</nav>

	<div class="nav-hamburger" @click="hamburgerOn = !hamburgerOn">
		<i class="fas fa-bars"></i>
	</div>

	<transition name="dropdown">
		<div class="flight-deck-nav-pane" v-if="showFlightDeckNavPane">

			<div class="column-common">
				<template v-for="(menuItem, index) in flightDeckMetaMenu" v-if="Object.keys(flightDeckMetaMenu).length > 0">
					<router-link :to="(menuItem.link_type == 'home') ? '/' : '/' + menuItem.link_value" :key="'meta-menu-item-' + menuItem.menu_item_id" v-if="menuItem.link_type != 'external'">{{ menuItem.menu_label }}</router-link>
					<a :href="menuItem.link_value" v-else>{{ menuItem.menu_label }}</a>
				</template>
			</div>

			<div class="flight-deck-nav-pane-columns">

				<div class="span-all search">
					<input type="search" v-model="menuItemsSearchTerm" placeholder="Find a program by name">
					<ul class="filtered-search-menu-items" v-if="filteredSearchMenuItems.length > 0">
			            <li v-for="(item, index) in filteredSearchMenuItems">
							<router-link :to="item.parent_link_value" :key="'sub-menu-item-' + item.menu_item_id" v-if="menuItem.link_type != 'external'"></router-link>
							<a :href="item.link_value" :key="'sub-menu-item-search-' + item.menu_item_id" v-else>{{ item.menu_label }}</a>
			            </li>
			        </ul>
				</div>

				<div class="columns">
					<div class="flight-deck-nav-columns" v-for="(subMenu, index) in flightDeckMainMenu" :key="'sub-menu-' + index">
						<img v-bind:src="require('@/assets/img/Icon' + subMenu.menu_label.split(' ')[0] + '.png')" class="icon">
						<div>
							<div class="flight-deck-section-title">{{ subMenu.menu_label }}</div>
							<template v-for="(menuItem, index) in subMenu.menu_items" v-if="subMenu.menu_items && Object.keys(subMenu.menu_items).length > 0">
								<router-link :to="subMenu.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id" v-if="menuItem.link_type != 'external'"></router-link>
								<a :href="menuItem.link_value" :key="'sub-menu-item-nav-' + menuItem.menu_item_id" v-else>{{ menuItem.menu_label }}</a>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>

</header>

</template>

<script>
export default {
	name: 'cds-header',
	data() {
		return {
            loadingMenus: false,
			client: {},
			items_in_cart: 0,
			hamburgerOn: false,
			menuItemsSearchTerm: null,
			showFlightDeckNavPane: false,
			flightDeckMainMenu: {},
			flightDeckMetaMenu: {}
		}
	},
	watch: {
	    $route(){
	        this.showFlightDeckNavPane = false;
	    }
	},
 	created() {
	},
	computed: {
		flatMenuItems() {
			var flatMenuItems = []
			for (var key in this.flightDeckMainMenu) {
				// console.log(key, this.flightDeckMainMenu[key]);
				if (this.flightDeckMainMenu[key].menu_items) {
					for (var subKey in this.flightDeckMainMenu[key].menu_items) {
						this.flightDeckMainMenu[key].menu_items[subKey].parent_link_value = this.flightDeckMainMenu[key].link_value
						flatMenuItems.push(this.flightDeckMainMenu[key].menu_items[subKey])
					}
				}
			}
			return flatMenuItems
		},
		filteredSearchMenuItems() {
            if (!this.menuItemsSearchTerm || this.flatMenuItems.length == 0) {
                return []
            }
            var filteredSearchMenuItems = this.flatMenuItems.filter(item => {
                return item.menu_label.toLowerCase().indexOf(this.menuItemsSearchTerm.toLowerCase()) > -1
            })
            return filteredSearchMenuItems
        }
	},
	methods: {
		useRouterLink(baseLinkValue) {
			var basePath = process.env.BASE_URL.split('/')[1]
			return basePath == baseLinkValue
		},
		menuLink(parentLinkValue, menuItem) {
            if (!menuItem.link_value || menuItem.link_type == 'home') {
                return '/'
            } else {
                return (!menuItem.link_type || menuItem.link_type == 'page') ? '/' + parentLinkValue + '/' + menuItem.link_value
					: '/' + parentLinkValue + '/' + menuItem.link_type + '/' + menuItem.link_value
            }
        }
	}
}
</script>

<style lang="scss" scoped>
</style>
